(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yy-cart-complementary"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yy-cart-recommendations')) {
    customElements.define(
      'yy-cart-recommendations',
      class YYCartRecommendations extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          this.list = this.querySelector('[data-yy-cart-recommendations-list]');
          this.status = this.querySelector('[data-yy-cart-recommendations-status]');
          this.onClick = this.onClick.bind(this);
          this.addEventListener('click', this.onClick);

          this.loadRecommendations();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
        }

        get productIds() {
          return [...new Set(
            (this.dataset.productIds || '')
              .split(',')
              .map((value) => value.trim())
              .filter(Boolean)
          )];
        }

        get limit() {
          const value = Number.parseInt(this.dataset.limit || '3', 10);
          return Math.max(1, Math.min(Number.isNaN(value) ? 3 : value, 4));
        }

        async loadRecommendations() {
          if (!this.list || !this.dataset.recommendationsUrl) return;

          const cartProductIds = new Set(this.productIds);
          const collected = [];
          const collectedIds = new Set();

          for (const productId of this.productIds.slice(0, 4)) {
            if (collected.length >= this.limit) break;

            try {
              const url = new URL(this.dataset.recommendationsUrl, window.location.origin);
              url.searchParams.set('section_id', this.dataset.sectionId);
              url.searchParams.set('product_id', productId);
              url.searchParams.set('limit', String(this.limit));
              url.searchParams.set('intent', 'complementary');

              const response = await fetch(url.toString(), {
                headers: { Accept: 'text/html' },
                credentials: 'same-origin',
              });

              if (!response.ok) continue;

              const text = await response.text();
              const documentFragment = new DOMParser().parseFromString(text, 'text/html');

              documentFragment.querySelectorAll('[data-yy-cart-recommendation-card]').forEach((card) => {
                const recommendedProductId = card.dataset.productId;
                if (
                  !recommendedProductId ||
                  cartProductIds.has(recommendedProductId) ||
                  collectedIds.has(recommendedProductId) ||
                  collected.length >= this.limit
                ) {
                  return;
                }

                collectedIds.add(recommendedProductId);
                collected.push(card);
              });
            } catch (error) {
              console.error('Yu-Yulino cart recommendations:', error);
            }
          }

          this.list.replaceChildren(...collected);

          if (collected.length) {
            this.hidden = false;
          } else {
            this.hidden = true;
          }
        }

        async onClick(event) {
          const button = event.target.closest('[data-yy-cart-add]');
          if (!button || !this.contains(button)) return;

          event.preventDefault();
          if (button.disabled) return;

          const variantId = Number.parseInt(button.dataset.variantId || '', 10);
          if (!variantId) return;

          const originalText = button.textContent;
          button.disabled = true;
          button.classList.add('is-loading');
          button.textContent = 'Adding…';
          if (this.status) this.status.textContent = 'Adding item to cart';

          const linesUpdateDeferred = this.createCartLinesUpdateEvent(String(variantId));

          try {
            const response = await fetch(this.dataset.cartAddUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              credentials: 'same-origin',
              body: JSON.stringify({
                items: [{ id: variantId, quantity: 1 }],
                sections: ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'],
                sections_url: window.location.pathname,
              }),
            });

            const data = await response.json();

            if (!response.ok || data.status) {
              throw new Error(data.description || data.message || 'Could not add this item.');
            }

            this.updateCartSections(data.sections || {});

            const cartResponse = await fetch(`${this.dataset.cartUrl}.js`, {
              headers: { Accept: 'application/json' },
              credentials: 'same-origin',
              cache: 'no-store',
            });
            const cart = cartResponse.ok ? await cartResponse.json() : null;

            if (cart?.items) {
              this.dataset.productIds = [...new Set(
                cart.items.map((item) => String(item.product_id)).filter(Boolean)
              )].join(',');
              this.resolveCartLinesUpdate(linesUpdateDeferred, cart);
            } else {
              linesUpdateDeferred?.reject(new Error('Could not refresh cart data.'));
            }

            if (window.YYSnailProgressV3?.refresh) {
              window.YYSnailProgressV3.refresh();
            }

            if (this.status) this.status.textContent = 'Item added to cart';
            await this.loadRecommendations();
          } catch (error) {
            console.error('Yu-Yulino cart add:', error);
            linesUpdateDeferred?.reject(error);
            button.disabled = false;
            button.classList.remove('is-loading');
            button.textContent = originalText;
            if (this.status) {
              this.status.textContent = error.message || 'Could not add this item. Please try again.';
            }
          }
        }

        createCartLinesUpdateEvent(variantId) {
          const { CartLinesUpdateEvent } = window.StandardEvents || {};
          if (!CartLinesUpdateEvent) return null;

          const deferred = CartLinesUpdateEvent.createPromise();
          this.dispatchEvent(
            new CartLinesUpdateEvent({
              action: 'add',
              context: 'cart',
              lines: [{ merchandiseId: variantId, quantity: 1 }],
              promise: deferred.promise,
            })
          );
          return deferred;
        }

        resolveCartLinesUpdate(deferred, cart) {
          if (!deferred) return;
          const { CartLinesUpdateEvent } = window.StandardEvents || {};
          if (!CartLinesUpdateEvent) return;

          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          });
        }

        updateCartSections(sections) {
          if (sections['main-cart-items']) {
            const parsed = new DOMParser().parseFromString(sections['main-cart-items'], 'text/html');
            const source = parsed.querySelector('#main-cart-items .js-contents');
            const target = document.querySelector('#main-cart-items .js-contents');
            if (source && target) target.replaceChildren(...source.childNodes);
          }

          if (sections['main-cart-footer']) {
            const parsed = new DOMParser().parseFromString(sections['main-cart-footer'], 'text/html');
            const source = parsed.querySelector('#main-cart-footer .js-contents');
            const target = document.querySelector('#main-cart-footer .js-contents');
            if (source && target) target.replaceChildren(...source.childNodes);
          }

          if (sections['cart-icon-bubble']) {
            const parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
            const sourceWrapper = parsed.querySelector('#shopify-section-cart-icon-bubble, .shopify-section');
            const target = document.querySelector('#cart-icon-bubble');

            if (target) {
              target.innerHTML = sourceWrapper ? sourceWrapper.innerHTML : parsed.body.innerHTML;
            }
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
